<div class="relative">
    <div class="container w-[260px]  min-w-full">
      <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
        <div class="flex items-center gap-3 w-full">
          <div>
            <tui-svg src="tuiIconUsersLarge" style="color: black;"></tui-svg>
          </div>
          <div>
            <h3 class="flex items-center text-black text-[1.5rem] font-bold">Announcements</h3>
          </div>
        </div>
        <div class="flex gap-2 mt-3 sm:mt-0">
          <div class="">
            <button tuiButton appearance="" class="">
                   <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
                    <p class="flex justify-center items-center text-[13px] h-[24px]" (click)="navigateToAdd()">Add Announcement</p>
                   </div>
            </button>
          </div>
        </div>
    </div>
    <div class="my-2 sm:mt-0">
        <div *ngFor="let data of announcementData; let i = index" class="bg-[#faf0f2] rounded p-5 mt-2">
          <h5 class="text-[#A5A5A5]">Announcement Details</h5>
          <div class="flex w-full pt-3">
            <div class="hidden sm:block w-full">
              <table>
                <tbody>
                <tr class="align-top text-[#19191A]">
                  <td class="whitespace-nowrap pr-5">Subject :</td>
                  <td>{{ data.subject }}</td>
                </tr>
                <tr class="align-top text-[#19191A]">
                  <td class="whitespace-nowrap pr-5">Recipient :</td>
                  <td>{{ getRecipientLabel(data.recipient) }}</td>
                </tr>
                <tr class="align-top text-[#19191A]">
                  <td class="whitespace-nowrap pr-5">Message :</td>
                  <td>{{ data.message }}</td>
                </tr>
                </tbody>
              </table>
              <div class="flex flex-col mt-2">
                <div *ngIf="!data.isSend" class="flex gap-5 justify-end">
                  <button class="text-[#FF0000] hover:scale-110 transition-all duration-100" style="cursor: pointer" (click)="deleteAnnouncement(data._id)">Delete</button>
                  <button class="text-[#bb0021] hover:scale-110 transition-all duration-100" style="cursor: pointer" (click)="sendAnnouncement(data._id)">Send</button>
                </div>
              </div>
            </div>
              <div class="flex flex-col mt-2 gap-3 w-full sm:hidden">
                <div class="w-full flex flex-col sm:flex-row">
                  <p class="text-[#A5A5A5] w-[100px]">Subject :</p>
                  <p class="text-[#FFFFFF]">{{ data.subject }}</p>
                </div>
                <div class="w-full flex flex-col sm:flex-row">
                  <p class="text-[#A5A5A5] w-[100px]">Recipient :</p>
                  <p class="text-[#FFFFFF]">{{ getRecipientLabel(data.recipient) }}</p>
                </div>
                <div class="w-full  flex flex-col sm:flex-row">
                  <p class="text-[#A5A5A5] w-[100px]">Message :</p>
                  <p class="text-[#FFFFFF]">{{ data.message }}</p>
                </div>
                <div *ngIf="!data.isSend" class="w-full flex gap-5 justify-end items-end">
                  <button class="text-[#FF0000] hover:scale-110 transition-all duration-100" style="cursor: pointer" (click)="deleteAnnouncement(data._id)">Delete</button>
                  <button class="text-[#bb0021] hover:scale-110 transition-all duration-100" style="cursor: pointer" (click)="sendAnnouncement(data._id)">Send</button>
                </div>
              </div>
          </div>
        </div>
    </div>
      <div class="text-black py-10 flex justify-end w-full max-w-full">
        <tui-pagination
          [index]="pageSize.pageIndex-1"
          [length]="pageSize.length"
          (indexChange)="goToPage($event)"
          class="text-black">
        </tui-pagination>
      </div>
  </div>
</div>
